module.exports = __webpack_public_path__ + "img/y12.8fdfed9d.jpg";